import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    // 根路径重定向到 /oc
    path: '/',
    redirect: '/oc',
  },
  {
    path: '/oc',
    name: 'oc',
    component: () => import('../views/oc/Index.vue'),
  },
  {
    path: '/oc_demo',
    name: 'ocBookDemo',
    component: () => import('../views/oc/OCBookDemoView.vue'),
  },
  {
    path: '/ec',
    name: 'ec',
    component: () => import('../views/ec/Index.vue'),
  },
  {
    path: '/ec_demo',
    name: 'ecBookDemo',
    component: () => import('../views/ec/ECBookDemoView.vue'),
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('../views/about-us/index.vue'),
  },
  {
    path: '/oc/lc',
    name: 'lc',
    component: () => import('../views/livechat'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
